import { render, staticRenderFns } from "./BaseProgress.vue?vue&type=template&id=fae3bd64"
import script from "./BaseProgress.vue?vue&type=script&lang=js"
export * from "./BaseProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fae3bd64')) {
      api.createRecord('fae3bd64', component.options)
    } else {
      api.reload('fae3bd64', component.options)
    }
    module.hot.accept("./BaseProgress.vue?vue&type=template&id=fae3bd64", function () {
      api.rerender('fae3bd64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseProgress.vue"
export default component.exports